import { C_Event } from "./event.model";

export class C_EventosRM {
  Eventos: C_Event[];
  LeagueName: string;

  constructor(evento: C_Event[], leagueName: string) {
    this.Eventos = evento;
    this.LeagueName = leagueName;
  }
}
